import { EventEmitter } from 'events';
import { socketService } from './socketService';
import { socketEventTypes } from '../constants';
import { featureFlagsService } from '../featureFlagsService';
import { testResultServiceSocketIO } from './testResultServiceSocketIO';

class TestResultService extends EventEmitter {
    init(projectId: string) {
        if (featureFlagsService.flags.useNewWSCLI.isEnabled()) {
            socketService.onConnect = () => this.emit('socket-connected');
            return;
        }
        testResultServiceSocketIO.init(projectId);
        testResultServiceSocketIO.onConnect = () => this.emit('socket-connected');
    }

    joinToTestResult(resultId: string, testId: string) {
        //TODO - Consider unifying the joinToTestResult and listenToTestResult flows
        if (featureFlagsService.flags.useNewWSCLI.isEnabled()) {
            return socketService.addFilter(`${resultId}:testResult`, { resultId, testId }, [
                socketEventTypes.TEST_RESULT_UPDATED,
                socketEventTypes.TEST_RESULT_CREATED,
            ]);
        }
        return testResultServiceSocketIO.joinToTestResult(resultId, testId);
    }

    async leaveTestResult(resultId: string, testId: string) {
        if (featureFlagsService.flags.useNewWSCLI.isEnabled()) {
            socketService.removeFilter(`${resultId}:testResult`, [socketEventTypes.TEST_RESULT_UPDATED, socketEventTypes.TEST_RESULT_CREATED]);
            return;
        }

        await testResultServiceSocketIO.leaveTestResult(resultId, testId);
    }

    listenToTestResult(resultId: string, testId: string, onTestResultStatus: (testResult: any) => void) {
        if (featureFlagsService.flags.useNewWSCLI.isEnabled()) {
            socketService.listenTo(
                `${resultId}:testResult`,
                [socketEventTypes.TEST_RESULT_UPDATED, socketEventTypes.TEST_RESULT_CREATED],
                (data: any) => data.resultId === resultId && data.testId === testId,
                (data: any) => onTestResultStatus(data),
            );
            return;
        }

        testResultServiceSocketIO.listenToTestResult(resultId, testId, onTestResultStatus);
    }

    // Unused
    getSocket() {
        if (featureFlagsService.flags.useNewWSCLI.isEnabled()) {
            return undefined;
        }
        return testResultServiceSocketIO.getSocket();
    }
}

export const testResultService = new TestResultService();
